module.exports = __webpack_public_path__ + "img/lzf.19a9f1b1.png";